var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyePass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 20,
    viewBox: "0 0 14 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2e3546",
    strokeMiterlimit: 50,
    d: "M8.887 5.375c0 .906-.731 1.636-1.637 1.636-.905 0-1.636-.73-1.636-1.636 0-.905.73-1.636 1.636-1.636.906 0 1.637.73 1.637 1.636zM7.25 1.285a6.451 6.451 0 0 0-6 4.09 6.451 6.451 0 0 0 6 4.091 6.451 6.451 0 0 0 6-4.09 6.451 6.451 0 0 0-6-4.092z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyePass);
export default __webpack_public_path__ + "static/media/eye_pass.f265cd6a557c7af9bac28516452ed13a.svg";
export { ForwardRef as ReactComponent };